/**
 * The date the customer-facing policy terms last changed materially.
 *
 * Shared by all four policy pages so they cannot drift apart — four
 * independently maintained dates would disagree within a month, and a policy
 * page whose date contradicts its neighbour is worse than one with no date.
 *
 * Update this ONLY for a substantive change to the terms themselves. A typo
 * fix or a layout change is not a new effective date: the date is what a
 * customer (or a payment processor reviewing a dispute) uses to know which
 * version of the contract applied to their purchase.
 *
 * Last changed for: refunds are provided when the tool is visible on the
 * screen, reported within 24 hours of the incident with video evidence.
 */
export const POLICY_EFFECTIVE_DATE = "2026-08-25"

export const POLICY_EFFECTIVE_LABEL = new Date(POLICY_EFFECTIVE_DATE).toLocaleDateString("en-GB", {
  day: "numeric",
  month: "long",
  year: "numeric",
})
